<template>
    <div class="bizcomp-fund-market white-bg">
        <div class="fund-types">
            <div style="display: flex; align-items: center">
                <span style="color: var(--color-text-regular)">基金类型：</span>
                <el-radio-group v-model="activeType" size="mini">
                    <el-radio-button v-for="item in fundTypes" :key="item.val" :label="item.val">
                        {{ item.text }}
                    </el-radio-button>
                </el-radio-group>
            </div>

            <div class="fund-search">
                <el-autocomplete
                    v-model="searchText"
                    popper-class="my-autocomplete"
                    placeholder="基金品代码/名称"
                    class="input-search"
                    size="small"
                    :fetch-suggestions="querySearchAsync"
                    v-on:select="handleSelect"
                >
                    <template slot-scope="{ item }">
                        <div class="name">
                            {{ item.value }}
                        </div>
                    </template>
                    <el-button
                        slot="suffix"
                        icon="el-icon-search"
                        class="search-icon"
                        type="text"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-autocomplete>
            </div>
        </div>

        <!-- 基金经理：单独一行 -->
        <div class="fund-types fund-manager-wrapper">
            <span class="fund-label">基金经理：</span>

            <el-radio-group v-model="fundManager" size="mini" class="fund-manager-all">
                <el-radio-button label="">全部</el-radio-button>
            </el-radio-group>

            <el-radio-group v-model="fundManager" size="mini" class="fund-manager-list">
                <el-radio-button
                    v-for="item in fundManagerList"
                    :key="item.managerid"
                    :label="item.managerid"
                >
                    {{ item.managername }}
                </el-radio-button>
            </el-radio-group>
        </div>

        <fund-list
            :has-load="hasLoad"
            :fund-info="fund"
            :tab-index="activeType"
            :all-page="allPage"
            :hide-currency-stage="hideCurrencyStage"
            v-on:new-fund="newFund"
            v-on:fund-continue="fundBuy"
            v-on:sort-change="handleFundSortChange"
        />
        <fund-risk-filter :quick-buy="true" :qryall="ismatch" v-on:qry-change="qryChange" />
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/fund/buyFundList";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import fundApi from "@/api/fund";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import { getRiskFilter, isValidProfessionalInvestor } from "@/util";

export default {
    name: "FundMarket",
    components: {
        fundList,
        fundRiskFilter,
        fundSdxDialog
    },
    mixins: [mixin],
    data() {
        return {
            ismatch: getRiskFilter(), // 是否只看风险匹配
            searchText: "", // 搜索文本内容
            fund: [], // 基金信息
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            sortField: "", // 排序字段
            sortOrder: "", // 排序方向 "" 不排序 "ascending" 升序 "descending" 降序
            activeType: "", // 基金类型
            hasLoad: false, // 是否已经查询数据
            sdxFundInfo: {},
            sdxDialogVisible: false,
            fundTypes: [],
            fundclass: "", // 公私募标记
            fundManager: "", // 当前选中的基金经理
            fundManagerList: [] // 基金经理列表
        };
    },
    computed: {
        hideCurrencyStage() {
            return this.$cache.getCompanyInfoParam("10102049") === "0";
        }
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchFund();
            }
        },
        activeType(val) {
            this.searchFund();
        },
        fundManager() {
            this.pageoffset = 1;
            this.doAction();
        }
    },
    async created() {
        this.$store.commit("updateLoadFund", false);
        const info = this.$cache.getUser();
        if (!isValidProfessionalInvestor()) {
            this.ismatch = info.ismatch || "1";
        }
        this.riskList = this.$cache.getDict("110143");
        this.fundclass = this.$util.getFundClass();
        let fundclassList =
            (this.$cache.getParamValue("fund_market") &&
                this.$cache.getParamValue("fund_market").fundshowtypes) ||
            [];
        // 判断脚本是否有热销基金这项
        let hasTargetItem = fundclassList.some((item) => item.subitem === "47223");
        // 处理基金超市展示的列表项
        const convertedApiTabs = fundclassList.map((item) => ({
            val: item.subitem != "47223" ? item.subitem : "hot",
            text: item.subitemname
        }));
        if (hasTargetItem) {
            const res = await fundApi.getFundLists({
                tagids: "47223",
                pagesize: 10,
                pagenum: 1
            });
            // 如果没有热销基金 不展示此tab
            if (res.data.list.length == 0) {
                hasTargetItem = false;
                convertedApiTabs.shift();
            }
        }
        this.fundTypes =
            this.fundclass == "1"
                ? JSON.parse(JSON.stringify(this.$util.getConfig().privateFundTypes))
                : convertedApiTabs;
        this.activeType = this.fundclass == "1" ? "999" : hasTargetItem ? "hot" : "";
        this.getFundManagerList();
        this.doAction();
    },
    methods: {
        // 处理基金适当性信息
        fundBuy(way, val) {
            this.sdxFundInfo = {};
            // 普通购买/定投
            if (way === "20,22") {
                val._url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                val._url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const isNeedSdxCheck = this.$util.isNeedSdxCheck(val);
                    if (!isNeedSdxCheck) {
                        val.way = way; // 添加 way 字段，供 buyCompDC.vue 计算 isPwdCheck
                        this.$util.grantTradeSdxAccessAndStoreFund(val._url, val);
                        this.$router.push({ name: val._url, query: { fundcode: val.fundcode } });
                        return;
                    }
                    this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            const _x = Object.assign({}, data, { way: way });
                            this.sdxFundInfo = _x;
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            this.$util.grantTradeSdxAccessAndStoreFund(this.sdxFundInfo._url, this.sdxFundInfo);
            this.$router.push({
                name: this.sdxFundInfo._url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.pageoffset = 1;
            this.doAction();
        },
        // 搜索基金
        searchFund() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            let _cbArr = [];
            this.doAction(queryString, (res) => {
                // res.forEach((item, index) => {
                //     let _x = {};
                //     _x.value = item.fundname + "(" + item.fundcode + ")";
                //     _x.id = item.fundcode;
                //     _x.index = index;
                //     _cbArr.push(_x);
                // });
            });
            cb(_cbArr);
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 表头排序
        handleFundSortChange({ prop, order }) {
            if (order) {
                this.sortField = prop;
                this.sortOrder = order;
            } else {
                this.sortField = "";
                this.sortOrder = "";
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const exType = ["999", "0", "zghr", "hot"];

            let orderfield = "";
            let isasc = "";
            if (this.sortField) {
                if (this.sortField === "nav") {
                    orderfield = this.activeType === "5" ? "fundincomeunit" : "nav";
                } else if (this.sortField === "dayfloatprofit") {
                    orderfield = this.activeType === "5" ? "growthrate" : "dayfloatprofit";
                } else {
                    orderfield = this.sortField;
                }
                isasc = this.sortOrder === "ascending" ? "1" : "0";
            }

            const _x = {
                tagids: this.activeType === "hot" ? "47223" : "",
                fundshowtype: exType.includes(this.activeType) ? "" : this.activeType,
                ismatch: this.ismatch,
                valuagrbuystate: "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: cb ? 20 : this.pagecount,
                pagenum: val ? 1 : this.pageoffset,
                tradingmethod: this.$util.getConfig().systemtype,
                orderfield: orderfield,
                isasc: isasc,
                mrfflag: this.activeType === "zghr" ? "1" : undefined,
                fundclass: this.fundclass,
                managercode: this.fundManager
            };
            const res = await fundApi.getFundLists(_x);
            this.hasLoad = true;
            if (res.data) {
                this.$store.commit("updateLoadFund", true);
                if (this.pageoffset == 1) {
                    this.allPage = "0";
                }
                _this.fund = res.data.list;
                if (this.activeType === "hot" && !_this.fund.length) {
                    _this.fundTypes.shift();
                    _this.activeType = "";
                    _this.doAction();
                }
                let xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
                if (xjbFundInfo) {
                    _this.fund = _this.fund.filter((item) => {
                        return item.fundcode !== xjbFundInfo.fundcode;
                    });
                }

                // 记录过滤状态
                const info = _this.$cache.getUser();
                info.ismatch = _this.ismatch;
                _this.$store.dispatch("setInfo", info);
                _this.allPage = res.data.total.toString();
                if (cb) {
                    cb.call(_this, res.data.list);
                }
            }
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 切换类型tab
        handleClick(target) {
            this.pageoffset = 1;
            this.doAction();
        },
        async getFundManagerList() {
            const res = await fundApi.qryFundManagers();
            this.fundManagerList = res.data || [];
        }
    }
};
</script>

<style lang="scss">
.bizcomp-fund-market {
    margin-right: 20px;
    .fund-types {
        display: flex;
        padding: 0 0 20px;
        align-items: center;
        justify-content: space-between;
        .el-radio-button--mini .el-radio-button__inner {
            font-size: 14px;
            color: var(--color-text-regular);
            border: 1px solid var(--color-bg-page);
        }
        .fund-search {
            padding: 7px 0;
            .input-search {
                width: 230px;
                vertical-align: middle;
                .search-icon {
                    margin: 0 5px;
                    padding: 12.5px 0;
                    color: var(--color-primary);
                }
                .el-input__inner {
                    height: 40px;
                    border-bottom-right-radius: 0;
                    border-top-right-radius: 0;
                }
                .el-input-group__append {
                    background-color: var(--color-primary);
                    color: $text-color6;
                    font-size: $f20;
                    border-color: var(--color-primary);
                    padding: 0 10px;
                }
            }
        }
    }
}
.white-bg {
    background: var(--color-bg-page);
}
</style>

<style scoped>
/* 基金经理整行 */
.fund-manager-wrapper {
    display: flex;
    align-items: flex-start;
    padding-bottom: 20px;
}

/* label */
.fund-manager-wrapper .fund-label {
    flex-shrink: 0;
    line-height: 28px;
    color: var(--color-text-regular);
}

/* 全部 */

.fund-manager-all {
    flex-shrink: 0;
    /* margin-right: 8px; */
}

/* 基金经理列表 */
.fund-manager-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
}

/* 每个基金经理按钮宽度 */
.fund-manager-list .el-radio-button {
    width: 100px;
    box-sizing: border-box;
    margin-bottom: 6px;
}

/* 按钮内部 */
.fund-manager-wrapper .el-radio-button__inner {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

<style>
/* 修复选中状态的样式 - 非 scoped，确保能覆盖 Element UI 默认样式 */
.bizcomp-fund-market .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: var(--color-primary) !important;
    border-color: var(--color-primary) !important;
    color: var(--color-text-white) !important;
    box-shadow: -1px 0 0 0 var(--color-primary) !important;
}

.bizcomp-fund-market .el-radio-button__inner {
    border: 1px solid var(--color-bg-page);
}

.bizcomp-fund-market .el-radio-button__inner:hover {
    color: var(--color-primary);
}
</style>
